import { ISortBoxItemModel } from "../../SortBoxItem/ISortBoxItemModel";
import { CancellationReason } from "../../rxAutoMessages/rxAutoMessages";
import { IPayloadWrapper } from "../types/PayloadWrapper";

/**
 * -------------------------------------
 * Action Types definition
 * -------------------------------------
 * */
export const SET_AFRAME_BOX = "automatpacken/aframereviewbox/SET_AFRAME_BOX";
export const CLEAR = "automatpacken/aframereviewbox/CLEAR";
export const FETCH_AFRAME_REVIEW_BOX = "automatpacken/aframereviewbox/FETCH_AFRAME_REVIEW_BOX";
export const SET_IPACK_BOX_BARCODE = "automatpacken/aframereviewbox/SET_IPACK_BOX_BARCODE";
export const SET_ORDER_CHECKED = "automatpacken/aframereviewbox/SET_ORDER_CHECKED";
export const SET_ALL_SORTBOXITEMS = "automatpacken/aframereviewbox/SET_ALL_SORTBOXITEMS";
export const SET_AFRAME_SORTBOXITEMS = "automatpacken/aframereviewbox/SET_AFRAME_SORTBOXITEMS";
export const SET_MISSING_BOX_ITEM = "automatpacken/aframereviewbox/SET_MISSING_BOX_ITEM";
export const VERIFY_RX_BAGS_REQUIRED = "automatpacken/aFrameAppMode/VERIFY_RX_BAGS_REQUIRED";
export const SET_VERIFIED_RX_BAGS_EAN = "automatpacken/aFrameAppMode/SET_VERIFIED_RX_BAGS_EAN";
export const SET_CONFIRM_WRONG_RX_BAG_SCAN =
  "automatpacken/aFrameAppMode/SET_CONFIRM_WRONG_RX_BAG_SCAN";

export const setConfirmWrongRxBagScan = (payload: IPayloadWrapper<string[]>) => {
  return {
    type: SET_CONFIRM_WRONG_RX_BAG_SCAN,
    payload,
  };
};

export const setVerifiedRxBagsEAN = (payload: IPayloadWrapper<string[]>) => {
  return {
    type: SET_VERIFIED_RX_BAGS_EAN,
    payload,
  };
};

export const verifyRxBagsRequired = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: VERIFY_RX_BAGS_REQUIRED,
    payload,
  };
};
/**
 * -------------------------------------
 * Action Creator definitions
 * -------------------------------------
 * */
export const setReviewBoxData = (payload: {
  reviewBox: any;
  aFrameAction: number;
  focusCallback: () => void;
}) => {
  return {
    type: SET_AFRAME_BOX,
    payload,
  };
};

export const clearReviewBoxData = () => {
  return {
    type: CLEAR,
  };
};

export const fetchAFrameReviewBox = (payload: {
  type: number;
  input: string;
  callback: (() => void) | undefined;
  errorCallback: (input: string) => void;
  focusCallback: () => void;
}) => {
  return {
    type: FETCH_AFRAME_REVIEW_BOX,
    payload,
  };
};

export const setIPackBoxBarcode = (payload: IPayloadWrapper<string>) => {
  console.log("SETTING BARCODE IPACK");
  return {
    type: SET_IPACK_BOX_BARCODE,
    payload,
  };
};

export const setOrderChecked = (payload: IPayloadWrapper<boolean>) => {
  return {
    type: SET_ORDER_CHECKED,
    payload,
  };
};

export const setAllSortboxItems = (payload: IPayloadWrapper<ISortBoxItemModel>) => {
  return {
    type: SET_ALL_SORTBOXITEMS,
    payload,
  };
};

export const setAframeSortboxItems = (payload: IPayloadWrapper<ISortBoxItemModel>) => {
  return {
    type: SET_AFRAME_SORTBOXITEMS,
    payload,
  };
};

export const setMissingBoxItem = (payload: IPayloadWrapper<ISortBoxItemModel>) => {
  return {
    type: SET_MISSING_BOX_ITEM,
    payload,
  };
};

const initialState = {
  notFound: false,
  channelItems: [],
  iPackBoxID: -1,
  estimatedWeight: -1,
  warnings: [],
  hasWarnings: false,
  orderNumber: -1,
  boxItems: [],
  boxID: -1,
  sortID: -1,
  sortBoxModel: null,
  latestShipping: "1950-01-01",
  shippingMethod: -1,
  iPackBoxBarcode: "",
  orderChecked: false,
  allSortBoxItems: [],
  cancellationReason: CancellationReason.undefined,
  missingBoxItem: null,
  warningMessage: null,
  verifyRxBagsRequired: false,
  verifiedRxBagsEan: [],
  confirmWrongRXScan: false,
  supplierDeliveryId: null,
};

/**
 * -------------------------------------
 * Reducer definition
 * -------------------------------------
 * */
const aFrameReviewBoxReducer = (state = { ...initialState }, action: any) => {
  switch (action.type) {
    case SET_AFRAME_BOX:
      return { ...state, ...action.payload.reviewBox };
    case CLEAR:
      return { ...state, ...initialState };
    case SET_IPACK_BOX_BARCODE:
      return { ...state, iPackBoxBarcode: action.payload.value };
    case SET_ORDER_CHECKED:
      return { ...state, orderChecked: action.payload.value };
    case SET_ALL_SORTBOXITEMS:
      return { ...state, allSortBoxItems: action.payload.value };
    case SET_AFRAME_SORTBOXITEMS:
      return { ...state, boxItems: action.payload.value };
    case SET_MISSING_BOX_ITEM:
      return { ...state, missingBoxItem: action.payload.value };
    case VERIFY_RX_BAGS_REQUIRED:
      return {
        ...state,
        verifyRxBagsRequired: action.payload.value,
        verifiedRxBagsEan: [],
        confirmWrongRXScan: false,
      };
    case SET_VERIFIED_RX_BAGS_EAN:
      return { ...state, verifiedRxBagsEan: action.payload.value };
    case SET_CONFIRM_WRONG_RX_BAG_SCAN:
      return { ...state, confirmWrongRXScan: action.payload.value };
    default:
      return state;
  }
};

/**
 * -------------------------------------
 * Public interface
 * -------------------------------------
 * */
export default aFrameReviewBoxReducer;
